<template>
  <div class="layout__position-center text__align-center mt-auto pt-25px">
    <h2 class="text__colour-teal layout__margin__bottom-20">
      Thank you
    </h2>

    <div>
      <p class="layout__margin__bottom-20">
        Your request has gone to our accounts team<br>
        to finalise which could take up to 48 hours.
      </p>
      <p class="layout__margin__bottom-20">
        If we need further information we'll be in touch,<br>
        otherwise you'll receive an email <br>
        once your account is ready to use.
      </p>
      <p class="layout__margin__bottom-20">
        Subject to standard credit checks, you'll have the option <br>
        of paying via monthly invoices or <br>
        via a credit or debit card at checkout.
      </p>
      <h3 class="layout__margin__bottom-20 text__colour-teal">
        In a hurry?
      </h3>
      <p class="layout__margin__bottom-20">
        Speak to our Customer Service team to order now
      </p>
      <p class="layout__margin__bottom-20">
        t: {{ supportPhone }}<br>
        e: {{ supportEmail }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FinishedRegistration',

  created() {
    localStorage.removeItem('isFinishedRegistration');
  },

  data() {
    return {
      supportEmail: 'client.support@ravensworth.co.uk',
      supportPhone: '0191 917 9331',
    };
  },
};
</script>